import React, { useState, useEffect } from "react";
import braintree from "braintree-web";

const Payment = () => {
  // Replace 'YOUR_SERVER_ENDPOINT' with the actual endpoint on your server
  const serverEndpoint = "/your-server-endpoint";

  const [clientToken, setClientToken] = useState("");
  const [instance, setInstance] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClientToken = async () => {
      try {
        const response = await fetch(serverEndpoint);
        const data = await response.json();
        console.log(data)
        setClientToken(data.clientToken);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching client token:", error);
      }
    };

    fetchClientToken();
  }, []);

  useEffect(() => {
    const initializeBraintree = async () => {
      try {
        const clientInstance = await braintree.client.create({
          authorization: clientToken,
        });

        const dropinInstance = await braintree.dropin.create({
          authorization: clientToken,
          container: "#dropin-container",
        });

        setInstance(dropinInstance);
      } catch (error) {
        console.error("Error initializing Braintree:", error);
      }
    };

    if (clientToken || !loading) {
      initializeBraintree();
    }
  }, [clientToken, loading]);

  const handlePayment = async () => {
    try {
      const { nonce } = await instance.requestPaymentMethod();
      // Send the nonce to your server for processing (for testing, you can log it)
      console.log("Payment nonce:", nonce);
    } catch (error) {
      console.error("Error processing payment:", error);
    }
  };

  return (
    <div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div id="dropin-container"></div>
          <button onClick={handlePayment}>Submit Payment</button>
        </>
      )}
    </div>
  );
};

export default Payment;
 
// ----------------------------------   OLD CODE   ---------------------------------

// import React, { useState, useEffect } from "react";
// import braintree from "braintree-web";

// export default function Payment() {
//     const dummyClientToken = 'AItsbgd28xdjdkhdo';

//     const [clientToken, setClientToken] = useState('');
//     const [instance, setInstance] = useState(null);
  
//     useEffect(() => {
//       // For testing, use the dummy client token
//       setClientToken(dummyClientToken);
//     }, []);
  
//     const initializeBraintree = async () => {
//       try {
//         const clientInstance = await braintree.client.create({
//           authorization: clientToken,
//         });
  
//         const dropinInstance = await braintree.dropin.create({
//           authorization: clientToken,
//           container: '#dropin-container',
//         });
  
//         setInstance(dropinInstance);
//       } catch (error) {
//         console.error('Error initializing Braintree:', error);
//       }
//     };
  
//     useEffect(() => {
//       if (clientToken) {
//         initializeBraintree();
//       }
//     }, [clientToken]);
  
//     const handlePayment = async () => {
//       try {
//         const { nonce } = await instance.requestPaymentMethod();
//         // Send the nonce to your server for processing (for testing, you can log it)
//         console.log('Payment nonce:', nonce);
//       } catch (error) {
//         console.error('Error processing payment:', error);
//       }
//     };
  
//     return (
//       <div>
//         <div id="dropin-container"></div>
//         <button onClick={handlePayment}>Submit Payment</button>
//       </div>
//     );
//   }
